<template>
  <v-container style="max-width: 940px;">
    <h1>{{title}}</h1>
    <v-parallax v-if="!!imageId" :src="`https://res.cloudinary.com/hortusbox/image/upload/c_fit,h_400/${imageId}.jpg`"></v-parallax>
    <p v-if="!!content" v-html="content"></p>
    <v-parallax v-if="!!imageFooterId" :src="`https://res.cloudinary.com/hortusbox/image/upload/c_fit,h_400/${imageFooterId}.jpg`"></v-parallax>
    <br/>
    <br/>
    <br/>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    post: {}
  }),
  computed: {
    title () {
      return this.post && this.post.title ? this.post.title : ''
    },
    imageId () {
      return this.post && this.post.image && this.post.image.public_id ? this.post.image.public_id : ''
    },
    imageFooterId () {
      return this.post && this.post.imageFooter && this.post.imageFooter.public_id ? this.post.imageFooter.public_id : ''
    },
    content () {
      return this.post && this.post.content && this.post.content.extended ? this.post.content.extended : ''
    }
  },
  mounted () {
    this.$vuetify.goTo(0)
    axios.get(process.env.VUE_APP_BASE_URL+'/api/post/'+this.$route.params.slug)
    .then( (res) => {
      this.post = res.data
    })
    .catch( (err) => {
      console.log(err)
    })
  }
}
</script>

<style scoped>
h1 {
  color: #0b755f;
}
</style>